export default __webpack_public_path__ + "static/media/Hamsa White Transparent.59c1031c.png";